import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const ReplyAllIcon: FC<Props> = ({ className, size = 20, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.66699 14.1667L1.66699 9.16669L6.66699 4.16669L7.85449 5.33335L4.02116 9.16669L7.85449 13L6.66699 14.1667ZM16.667 15.8334V12.5C16.667 11.8056 16.4239 11.2153 15.9378 10.7292C15.4517 10.2431 14.8614 10 14.167 10H9.02116L12.0212 13L10.8337 14.1667L5.83366 9.16669L10.8337 4.16669L12.0212 5.33335L9.02116 8.33335H14.167C15.3198 8.33335 16.3024 8.7396 17.1149 9.5521C17.9274 10.3646 18.3337 11.3472 18.3337 12.5V15.8334H16.667Z" />
    </svg>
  );
};
